const SelectedDistrictSlugCookie = 'selectedDistrictSlug';
export default SelectedDistrictSlugCookie;
